
let Api = {
  "AM_FINDNOTAUTHLIST": '/portal-api/am/findNotAuthList',//轮播图
  "VARIETY_LIST": '/portal-api/n/variety/list',//获取启用的中药材目录品种管理列表
  "VARIETY_GET": '/portal-api/n/variety/get',//查询中药材目录品种管理
  "COMMDITY_SEARCH": "/trade/n/search1",//首页商品搜索 
  'BUYER_HOME_FINDENTPLIST': "/trade/n/buyer/home/findEntpList",//首页商家列表
  "PORTAL_N_VARIETY_PAGE": "/portal-api/n/variety/page",//品种名录
  
	"N_PROTOCOL_GETPROTOCOLINFO": "/portal-api/n/protocol/getProtocolInfo", //查询会员基本信息
}
module.exports = Api